import BaseDevice from '../base.js'
import Switch from '../rcd/switch.js'
import Point from '../rcd/point.js'
export default class DeviceImage extends BaseDevice {

   static render = (device, scale = 1) => {
      let MODS = this.getMods(device.width)
      if (MODS < 3 || MODS > 6) return;
      const SWITCHES = MODS >= 3 ? 3 : MODS - 1
      const switchSVG = Switch.render(device.width, SWITCHES);
      const pointSVG = Point.render();
      return this.getDevice(device, scale, pointSVG + switchSVG);
   }
}
